module.exports = __webpack_public_path__ + "static/media/tile_web.2e1ac64a.svg";